import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	displayAsLabel: {
		id: 'custom-sites-extensions.link-cards.link-cards-config-panel.styles.display-as-label',
		defaultMessage: 'Display as',
		description:
			'A visible text label for the cards orientation section of the link cards config panel that informs the user that they can select either row or stacked view. This can also be translated as display.',
	},
	rowItemLabel: {
		id: 'custom-sites-extensions.link-cards.link-cards-config-panel.styles.row-label',
		defaultMessage: 'Row',
		description:
			'A visible label for the selectable option to change the cards orientation to row for link cards',
	},
	rowItemDescription: {
		id: 'custom-sites-extensions.link-cards.link-cards-config-panel.styles.row-description',
		defaultMessage: 'Cards scroll in one row',
		description:
			'A visible description for the selectable option to change the cards orientation to row for link cards to inform the user of how this option will look',
	},
	stackedItemLabel: {
		id: 'custom-sites-extensions.link-cards.link-cards-config-panel.styles.stacked-label',
		defaultMessage: 'Stacked',
		description:
			'A visible label for the selectable option to change the cards orientation to stacked for link cards',
	},
	stackedItemDescription: {
		id: 'custom-sites-extensions.link-cards.link-cards-config-panel.styles.stacked-description',
		defaultMessage: 'Cards wrap to new lines',
		description:
			'A visible description for the selectable option to change the cards orientation to stacked for link cards to inform the user of how this option will look',
	},
});
